import { createServer } from 'miragejs'
import appConfig from 'configs/app.config'

// ==> Data
import { signInUserData } from './data/authData'
import { plansData } from './data/plansData'
import { clientsData } from './data/clientsData'

// ==> API
import { authFakeApi, plansFakeApi, clientsFakeApi } from './fakeApi'

const { apiPrefix } = appConfig

export default function mockServer({ environment = 'test' }) {
    return createServer({
        environment,
        seeds(server) {
            server.db.loadData({
                signInUserData,
                plansData,
                clientsData,
            })
        },
        routes() {
            this.urlPrefix = ''
            this.namespace = ''
            this.passthrough((request) => {
                let isExternal = request.url.startsWith('http')
                return isExternal
            })
            this.passthrough()

            authFakeApi(this, apiPrefix)
            plansFakeApi(this, apiPrefix)
            clientsFakeApi(this, apiPrefix)
        },
    })
}
